import Base from 'app/models/base';

export default Base.extend({
  imageUrl() {
    return this.get('label_url');
  },
});



// WEBPACK FOOTER //
// ./app/models/postage_label.js